import cn from '../Utils/cn';

type Props = {
	htmlFor: string;
	required?: boolean;
	children?: React.ReactNode;
	suffix?: React.ReactNode;
} & React.ComponentPropsWithoutRef<'label'>;

const DefaultLabel: React.FC<Props> = ({ htmlFor, required = true, children, suffix = null, ...props }) => {
	return (
		<label htmlFor={htmlFor} className={cn('font-roboto text-lg font-medium leading-normal mb-[8px] flex justify-between md:block text-base-grey-5', props.className)} {...props}>
			{children}
			{!required && <span className="font-normal ml-[12px]">(opcional)</span>}
			{suffix}
		</label>
	);
};

export default DefaultLabel;
